module.exports = __webpack_public_path__ + "img/login_bg01.9f01c679.jpg";